import React from 'react'

import { Box, Flex, Text} from '@chakra-ui/react'
import {
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  IconButton,
  StatGroup,
  Heading,
  Center,
  Stack,
  Wrap,
  WrapItem,
} from '@chakra-ui/react'
import { EmailIcon, PhoneIcon, QuestionIcon } from '@chakra-ui/icons'
import { motion } from "framer-motion";

const Contact = () => {

  return (
    <Box>
      <motion.div
      className="box"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01]
      }}
    > 
    <Flex alignContent={'center'} justifyContent='center'>
    <Box style={{maxWidth:'980px'}} p={4}>
    <Text as='b' fontSize={{ base: '5xl', sm: '3xl', md: '4xl' }}>
        About Me!!
      </Text>
      <hr style={{marginTop:'20px',marginBottom:'20px'}}/>
      <br/>
      <Text as="b" fontSize={{ base: '3xl', sm: 'xl', md: '2xl' }}>
      Hola!!
      </Text><br/><br/>
      <Text fontSize={{ base: '2xl', sm: 'xl', md: 'xl' }} textAlign={'justify'}>
      My name is Gracy Patel and I am an under grad from Charusat University with majors in Computer Science and Engineering and a keen intrest towards design and development. I enjoy learning and exploring new trends and new possibilities. I like being minimal and simple.</Text>
      <br/>
      <br/>
      <Text fontSize={{ base: '2xl', sm: 'xl', md: 'xl' }} textAlign={'justify'}>
      Feel free to check my profiles and past projects.
      </Text>
      <br/>
      <hr/>
    <br/><br/>
    </Box>
    </Flex>
    <Wrap spacing='30px' justify='center'>
  <WrapItem border={'1px solid #888B8D'} rounded={5}>
    <Center w='300px' h='100px'>
    <IconButton
  variant='outline'
  colorScheme='teal'
  aria-label='Send email'
  icon={<EmailIcon />}
/> &nbsp;&nbsp;
<Text as='b'>gracy1168@gmail.com</Text>
    </Center>
  </WrapItem>
  <WrapItem border={'1px solid #888B8D'} rounded={5}>
    <Center w='300px' h='100px'>
    <IconButton
  variant='outline'
  colorScheme='teal'
  aria-label='Send email'
  icon={<PhoneIcon />}
/> &nbsp;&nbsp;
<Text as='b'>+91 7203051890</Text>
    </Center>
  </WrapItem>
  <WrapItem border={'1px solid #888B8D'} rounded={5}>
    <Center w='300px' h='100px'>
    <IconButton
  variant='outline'
  colorScheme='teal'
  aria-label='Send email'
  icon={<QuestionIcon />}
/> &nbsp;&nbsp;
<Text as='b'>Valsad, Gujarat</Text>
    </Center>
  </WrapItem>
</Wrap>
    </motion.div>
    </Box>
  )
}

export default Contact